import { observer } from "mobx-react-lite";
import React, { useEffect, Fragment } from "react";
import "./index.css";
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Space,Tooltip,
  Table, DatePicker, Dropdown, Menu, MenuProps, TreeSelect, Select,
} from "antd";
import {CommonStore, LanguageManageStore} from "../../../store";
import {DownOutlined, MoreOutlined} from "@ant-design/icons";
import RowDetail from "./rowDetail";
import AddOrUpdate from './update_or_add'
import dictionary from "../../../utils/dictionary";

function LanguageManage() {
  const [form] = Form.useForm();
  const { Column } = Table;
  const {RangePicker} = DatePicker;

  useEffect(() => {
    form.setFieldsValue({
      no: "",
      content: null,
      sceneId: null,
      status: null,
      isEnable: null,
      createUser: null,
      expireBeginDate: null,
      expireEndDate: null,
      auditLaunchBeginDate: null,
      auditLaunchEndDate: null,
      expireTime: null,
      auditLaunchDate: null,
    });
    resetSearchBth();
    LanguageManageStore.getSceneList()
  }, []);
  const getFormData = (changeValue: any, allValues: any) => {
    LanguageManageStore.setSearchForm({ ...allValues });
  };
  const resetSearchBth = () => {
    LanguageManageStore.setSearchForm({});
    searchBtn();
  };
  const searchBtn = () => {
    LanguageManageStore.resetPage();
    LanguageManageStore.getLanguagePage();
  };
  const handleMenuClick: MenuProps["onClick"] = (e) => {
    if (e.key === "1") {
      return LanguageManageStore.addOrUpdateModal.open("add");
    }
  };
  const items = [
    {
      label: "新增",
      key: "1",
      style: { display: CommonStore.pagePermission.writable ? "" : "none" },
    },
  ];
  const moreOperationsClick = (e: any, record: any) => {
    if (e.key === "1") {
      return LanguageManageStore.detailModal.open('detail',record)
    } else if (e.key === "2") {
      return LanguageManageStore.toDelete(record.id);
    }
  };
  const moreOperations = (record: any) => {
    return [
      {
        key: "1",
        label: "查看详情",
      },
      {
        label: "删除",
        key: "2",
        style: {color: "red",display: CommonStore.pagePermission.manageable&&record.status==='DRAFT' ? "" : "none"}
      },
    ];
  };

  return (
    <Fragment>
      <RowDetail/>
      <AddOrUpdate/>
        <div className="formContent">
          <Form
            form={form}
            initialValues={LanguageManageStore.searchForm}
            autoComplete="off"
            labelCol={{ span: 6 }}
            onValuesChange={getFormData}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === "enter") {
                searchBtn();
              }
            }}
          >
            <Row justify="start">
              <Col span={8}>
                <Form.Item label="话术编号" name="no">
                  <Input placeholder="请输入话术编号" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="话术内容" name="content">
                  <Input placeholder="请输入话术内容" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="场景类型" name="sceneId">
                  <TreeSelect
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
                      placeholder="请选择报备场景"
                      allowClear
                      treeDefaultExpandAll
                      fieldNames={{ value: "sceneId" }}
                      treeData={LanguageManageStore.accountSceneList}
                      maxTagCount="responsive"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="话术状态" name="status">
                  <Select placeholder="请选择话术状态" options={dictionary.languageStatus}/>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="创建人" name="createUser">
                  <Input placeholder="请输入创建人" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="到期时间" name="expireTime">
                  <RangePicker
                      placeholder={["开始时间", "结束时间"]}
                      format={'YYYY/MM/DD'}
                      style={{width:'100%'}}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="审核发起时间" name="auditLaunchDate">
                  <RangePicker
                      placeholder={["开始时间", "结束时间"]}
                      showTime
                  />
                </Form.Item>
              </Col>
              <Col offset={2}>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={searchBtn}>
                      搜索
                    </Button>
                    <Button htmlType="reset" onClick={resetSearchBth}>
                      重置
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              {(CommonStore.pagePermission.manageable) && (
                  <Col span={8} offset={16} style={{ marginBottom: "10px" }}>
                    <Dropdown
                        dropdownRender={(menu) => (
                            <Menu onClick={handleMenuClick} items={items} />
                        )}
                    >
                      <Button style={{ float: "right" }}>
                        <Space className="change">
                          变更
                          <DownOutlined />
                        </Space>
                      </Button>
                    </Dropdown>
                  </Col>
              )}
            </Row>
          </Form>
        </div>
        <div>
          <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={LanguageManageStore.tableData.content}
              rowKey={(record) => record.no}
              loading={LanguageManageStore.tableLoad}
              scroll={{ x: 1000 }}
              pagination={{
                current: LanguageManageStore.pageData.page+1,
                pageSize: LanguageManageStore.pageData.size,
                onChange: LanguageManageStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: LanguageManageStore.tableData.totalElements,
                showTotal: () =>
                  `共计${LanguageManageStore.tableData.totalElements
                  }条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                ellipsis={true}
                width={120}
                title="话术编号"
                dataIndex="no"
                render={(no) => (
                    <Tooltip placement="topLeft" title={no}>
                      {no}
                    </Tooltip>
                )}
              />
              <Column
                ellipsis={true}
                width={120}
                title="话术内容"
                dataIndex="content"
              />
              <Column
                ellipsis={true}
                width={100}
                title="话术状态"
                dataIndex="status"
                render={(status) =>
                    dictionary.languageStatus.find((item: any) => item.value == status)?.label
                }
              />
              <Column
                  ellipsis={true}
                  width={100}
                  title="合同链"
                  dataIndex="contractChain"
                  render={(contractChain) =>
                      contractChain &&contractChain.length?contractChain.length:0
                  }
              />
              <Column
                  ellipsis={true}
                  width={160}
                  title="到期时间"
                  dataIndex="expireDate"
              />
              <Column
                title="场景类型"
                width={120}
                dataIndex="sceneName"
                ellipsis={true}
              />
              <Column
                  title="创建人"
                  width={120}
                  dataIndex="createUser"
                  ellipsis={true}
              />
              <Column
                  title="创建时间"
                  width={160}
                  dataIndex="createTime"
                  ellipsis={true}
              />
              <Column
                  title="审核发起时间"
                  width={160}
                  dataIndex="auditLaunchDate"
                  ellipsis={true}
              />
              <Column
                  width={120}
                  fixed={"right"}
                  render={(text: string, record: any) => (
                      <Space>
                        {CommonStore.pagePermission.writable&&record.status!=='WAIT_AUDIT' && (
                            <Button
                                size={"small"}
                                onClick={() => LanguageManageStore.addOrUpdateModal.open("update",record)}
                            >
                              编辑
                            </Button>
                        )}
                        {/*{CommonStore.pagePermission.writable && (*/}
                            <Dropdown
                                dropdownRender={() => (
                                    <Menu
                                        onClick={(e) => moreOperationsClick(e, record)}
                                        className={"menuSty"}
                                        items={moreOperations(record)}
                                    />
                                )}
                            >
                              <Button size={"small"}>
                                <MoreOutlined />
                              </Button>
                            </Dropdown>
                        {/*)}*/}
                      </Space>
                  )}
              />
            </Table>
          </ConfigProvider>
        </div>
    </Fragment>
  );
}

export default observer(LanguageManage);
